export const colors = {
  // Primary brand colors (from nirva-web)
  primary: "#33261D", // Warm dark brown - headings, primary text
  secondary: "#29405A", // Navy blue - buttons, CTAs, links
  accent: "#E05C2B", // Orange accent
  calmBlue: "#74A9C8", // Active states, links

  // Text
  text: "#33261D",
  textLight: "#666",
  white: "#ffffff",
  black: "#000000",
  grey: "#9e9e9e",

  // Backgrounds
  background: "#F5F3ED", // Warm off-white page bg
  cardBg: "#FFFFFF",
  iconBg: "#F7F3F1", // Icon backgrounds, secondary surfaces
  headerBg: "#E6EBF0", // Header/navbar bg when scrolled
  hoverBg: "#f3f5f6",

  // Borders
  lightBorder: "#B4B2B2",
  stroke: "#D9CEC7",

  // Legacy
  primaryText: "#33261D",

  //Status
  success: "#409d45",
};

// Font stacks matching nirva-web
export const fonts = {
  gotham:
    'Gotham, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  quicksand: 'Quicksand, "Trebuchet MS", Arial, sans-serif',
  cinzel: 'Cinzel, Georgia, "Times New Roman", serif',
};

// Shadow tokens matching nirva-web
export const shadows = {
  card: "0 4px 12px rgba(0,0,0,0.08)",
  cardHover: "0 8px 24px rgba(0,0,0,0.1)",
  soft: "-4px -4px 17.8px 0px rgba(205, 214, 223, 0.15), 4px 4px 15px 0px rgba(205, 214, 223, 0.25)",
  modal: "0px 8px 32px rgba(0, 0, 0, 0.35)",
  small: "0 2px 8px rgba(0,0,0,0.08)",
};
